export const ADD_TO_NAV_HISTORY = 'ADD_TO_NAV_HISTORY'
export const GO_BACK_IN_HISTORY = 'GO_BACK_IN_HISTORY'
export const GO_FORWARD_IN_HISTORY = 'GO_FORWARD_IN_HISTORY'
export const NAVIGATE_TO_BREADCRUMB = 'NAVIGATE_TO_BREADCRUMB'

export const addToNavHistory = (route, title) => ({
  type: ADD_TO_NAV_HISTORY,
  payload: { route, title, timestamp: Date.now() },
})

export const goBackInHistory = () => ({
  type: GO_BACK_IN_HISTORY,
})

export const goForwardInHistory = () => ({
  type: GO_FORWARD_IN_HISTORY,
})

export const navigateToBreadcrumb = (index) => ({
  type: NAVIGATE_TO_BREADCRUMB,
  payload: index,
})
